module.exports = __webpack_public_path__ + "static/adjustable-base-2-feature-2ab0a5b47d62181be1d80755bf82b0fb.webp";